import { IconProps } from "design-system/types/types";

/**
 *
 * - **`id: P-015-000-00`**
 */
export function IconPlus({ className = "hbs-icon", ...props }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 12 12"
      fill="none"
      focusable="false"
      aria-hidden="true"
      {...props}
    >
      <path d="M0 6H12" strokeWidth="2" stroke="currentColor" />
      <path d="M6 12L6 0" strokeWidth="2" stroke="currentColor" />
    </svg>
  );
}
